import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import DashboardHome from "./DashboardHome";

import Centres from "./Centres";
import Machines from "./Machines";
import Userdata from "./Userdata";
import Projects from "./Projects";
import Supportdashboard from "./Supportdashboard";
import Ordermanagment from "./Ordermanagment";
import ExpertsManagement from "./ExpertsManagement";
import PromotionsDashboard from "./PromotionsDashboard";
import CentresAnalytics from "./CentresAnalytics";
import Reportsdata from "./Reportsdata";
import Registration from "./Registration ";
import Payments from "./Payments";
import Teammanagement from "./Teammanagement";
// import Quotations from "./Quotations";
// import Orders from "./Orders";
// import Billing from "./Billing";
// import Payments from "./Payments";
// import Operators from "./Operators";
// import Experts from "./Experts";
// import Inventory from "./Inventory";
// import Maintenance from "./Maintenance";
// import Quality from "./Quality";
// import Logistics from "./Logistics";

export default function Exports() {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <div className="flex h-screen bg-gray-100">
            <Sidebar
                collapsed={collapsed}
                setCollapsed={setCollapsed}
                basePath="/experts"
            />

            <div className="flex-1 flex flex-col overflow-hidden">
                <Topbar collapsed={collapsed} setCollapsed={setCollapsed} />

                {/* AdminDashboard is mounted at "/admin/*" in App.jsx,
                    so these paths are relative to "/admin"  */}
                <Routes>
                    <Route index element={<DashboardHome />} />
                    <Route path="centres" element={<Centres />} />
                    <Route path="machines" element={<Machines />} />
                    <Route path="bookings" element={<Centres />} />
                    <Route path="projects" element={<Projects />} />
                    <Route path="quotations" element={<Centres />} />
                    <Route path="orders" element={<Ordermanagment />} />
                    <Route path="billing" element={<Centres />} />
                    {/* <Route path="payments" element={<Centres />} /> */}
                    <Route path="operators" element={<Centres />} />
                    <Route path="experts" element={<Centres />} />
                    <Route path="inventory" element={<Centres />} />
                    <Route path="maintenance" element={<Centres />} />
                    <Route path="quality" element={<Centres />} />
                    <Route path="logistics" element={<Centres />} />
                    <Route path="support" element={<Supportdashboard />} />
                    <Route path="userdata" element={<Userdata />} />
                    <Route path="expertsmanagement" element={<ExpertsManagement />} />
                    <Route path="promotionsdashboard" element={<PromotionsDashboard />} />
                    <Route path="centresanalytics" element={<CentresAnalytics />} />
                    <Route path="reportsdata" element={<Reportsdata />} />
                    <Route path="registration" element={<Registration />} />

                    <Route path="payments" element={<Payments />} />
                    <Route path="teammanagement" element={<Teammanagement />} />

                </Routes>
            </div>
        </div>
    );
}